import './technology-spend.section.styles.scss';
import PlusIcon from "../../icons/plus.icon";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import CategoryItem from "./category-item.component";
import SortOrderListMenu from "./sort-order-list.menu";
import { CategoryManagementSOList, SortOrderList } from "../../../constants/filter.constants";
import UpdateCategoriesModal from "./update-categories-modal/update-categories.modal";
import ViewProductsModal from "./view-products-modal";
import ContentLoader from "react-content-loader";
import Suspense from "../../Common/suspense.component";
import { Loaders } from "../../../common/store/loaders/loaders.enum";
import { Dropdown, Spinner } from "react-bootstrap";
import CrossIcon from "../../icons/cross.icon";
import useTechnologySpendState from "./technology-spend.state";
import { CustomDeleteModal } from "../../DeleteModal/DeleteModal";
import { FlaggersMethods } from "../../../common/store/flaggers/flaggers.methods";
import ResetCategoryDropdown from "../../MSPv2/MspAttackSurface.js/reset-category.dropdown";
import { useRef } from "react";
import SearchFilterComponent from '../../Common/SearchFilterComponent/SearchFilterComponent';

const TechnologySpendSection = ({ isForStorefront = false, isView = false }) => {
  const SearchInput = useRef();
  const { 
    categories, defineOrder, search, filteredCategories, categoriesSortOrder, modals, categoryIsRemovingId,  
    handleSearchChange, handleSearchClear, deleteCategory, setModals, clientId, isLoadingCategories,
    handleSortOrderChange, handleAddCategory, onViewProductsClick, onCategoryUpdate, 
    handleDragEnd, handleSubCategoryDragEnd, setState, onCategoryDuplicate, handleOrderChange,
    selectedOrder, deleteCategoryPromptFlagger, setDeleteCategoryPromptFlagger,
    isLoadingDeleteCategory, refreshData,
  } = useTechnologySpendState({ isForStorefront });

  return (
    <div className="technology-spend-section">
      <Suspense fallback={<Loader />} loaders={Loaders.GetCategoriesLoader} forceShow={categories?.length > 0}>
        <div className="d-flex align-items-center gap-16">
          <div className="f-16 line-height-24 f-600 f-black">
            <span>Category Management</span>
          </div>
          {isLoadingCategories && (
            <Spinner 
              animation="border"
              variant="secondary"
              size="sm"
              style={{ width: '16px', height: '16px' }}
            />
          )}
        </div>
        <SearchFilterComponent
          passedRef={SearchInput}
          setRef={() => {
            SearchInput?.current?.focus()
          }}
          leftSide={(
            !isView && defineOrder ? (
              <div className="d-flex align-items-center gap-8">
                <Dropdown className="transparennt-wrapper-dropdown my-dropdown my-dropdown-common">
                  <Dropdown.Toggle>
                    <div className="grey-border radius-4 d-flex align-items-center gap-16 p-1 px-2">
                      <div className="f-grey f-14 line-height-22 f-400">
                        {defineOrder.label}
                      </div>
                      <div className="arrow-icon" />
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="menu w-100">
                    {CategoryManagementSOList.map((item) => (
                      <div 
                        key={item.value} 
                        className="item"
                        onClick={() => handleSortOrderChange(item)}
                      >
                        <span className="f-14 line-height-22 f-400 f-grey no-wrap">
                          {item.label}
                        </span>
                      </div>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                <CrossIcon 
                  width="12px" 
                  height="12px" 
                  className="f-dark-greyish pointer" 
                  onClick={() => setState(prev => ({ ...prev, defineOrder: null }))} 
                />
              </div>
            ) : <div />
          )}
          searchValue={search}
          searchOnChange={handleSearchChange}
          searchOnCross={handleSearchClear}
          showLastButton={!isView}
          lastButtonChild={(
            !isView && (
              <button 
                className="add-category-btn d-flex align-items-center gap-2"
                onClick={handleAddCategory}
              >
                <div 
                  className="d-flex align-items-center justify-content-center" 
                  style={{ width: '20px', height: '20px' }}
                >
                  <PlusIcon fill="#fff" width="14px" height="14px" />
                </div>
                <span className="f-14 line-height-22 f-500 f-white">
                  Add category
                </span>
              </button>
            )
          )}
          sortMenu={(
            !isView && (
              <SortOrderListMenu 
                sortOrderList={SortOrderList} 
                onDefineOrder={handleSortOrderChange} 
                onOrderChange={handleOrderChange} 
                selectedOrder={selectedOrder}
              />
            )
          )}
          visibilityFilters={isView ? [] : [
            {
              renderComponent: () => (
                <ResetCategoryDropdown 
                  resetForSO 
                  onSuccess={() => {
                    refreshData();
                  }} 
                  menuClass="reset-type-menu-cat-management"
                />
              )
            }
          ]}
        />
        <CategoriesList 
          filteredCategories={filteredCategories}
          categories={categories}
          handleDragEnd={handleDragEnd}
          categoriesSortOrder={categoriesSortOrder}
          setState={setState}
          deleteCategory={(props) => {
            setDeleteCategoryPromptFlagger(props, FlaggersMethods.UpdateFlagger);
          }}
          onViewProductsClick={onViewProductsClick}
          onCategoryUpdate={onCategoryUpdate}
          search={search}
          defineOrder={defineOrder}
          handleSubCategoryDragEnd={handleSubCategoryDragEnd}
          categoryIsRemovingId={categoryIsRemovingId}
          clientId={clientId}
          onCategoryDuplicate={onCategoryDuplicate}
          isForStorefront={isForStorefront}
          isView={isView}
        />
      </Suspense>
      <UpdateCategoriesModal 
        show={modals.updateCategories?.show} 
        onHide={() => setModals(prev => ({ ...prev, updateCategories: null }))} 
        clientList={modals.updateCategories?.clientList}
        productList={modals.updateCategories?.productList}
        categoryList={modals.updateCategories?.CategoryList}
      />
      <ViewProductsModal 
        show={modals.viewProducts?.show} 
        onHide={() => setModals(prev => ({ ...prev, viewProducts: null }))} 
        category={modals.viewProducts?.category}
      />
      <CustomDeleteModal
        processingText={"Please wait.."}
        show={!!deleteCategoryPromptFlagger}
        hideModal={(data) => {
          setDeleteCategoryPromptFlagger(null, FlaggersMethods.UpdateFlagger);
        }}
        deleteButtonClass={"hg-blue-btn"}
        deleteButtonText={"Delete"}
        deleteHeaderText={"Delete Category"}
        deleteBodyText={"Are you sure you want to delete this category?"}
        deleteFunction={() => {
          deleteCategory(deleteCategoryPromptFlagger);
        }}
        deleteParams={null}
        isLoading={isLoadingDeleteCategory}
      />
    </div>
  );
}

export default TechnologySpendSection;

const CategoriesList = ({ 
  filteredCategories, categories, handleDragEnd, categoriesSortOrder, setState, 
  deleteCategory, onViewProductsClick, onCategoryUpdate, search, defineOrder, handleSubCategoryDragEnd,
  categoryIsRemovingId, clientId, onCategoryDuplicate, isForStorefront = false, isView = false
}) => (
  filteredCategories?.length > 0 ? (
    <div className="categories-list">
      <div className="list-header">
        <div className="f-12 line-height-18 f-400 f-darkgrey header-title-wrapper">
          Categories
        </div>
        <div className="f-12 line-height-18 f-400 f-darkgrey d-flex align-items-center gap-8">
          <span className="header-item">Tech Spend</span>
          <span className="header-item">Storefront</span>
        </div>
      </div>
      <DragDropContext 
        onDragEnd={(result) => {
          if (isView) return;
          handleDragEnd(result, categories, 'Category');
        }}
        isDropDisabled={false}
        isCombineEnabled={false}
      >
        <Droppable
          direction="vertical"
          droppableId="droppableSection"
          isDropDisabled={isView}
          isCombineEnabled={false}
        >
          {(provided, snapshot) => (
            <div
              isDraggingOver={snapshot.isDraggingOver}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {filteredCategories.map((category, index) => {
                const subCategoriesSortOrder = categoriesSortOrder?.find((item) => item.Id === category.categoryId)?.SubCatList ?? [];
                return (
                  <CategoryItem 
                    key={`category-${category.categoryId}`} 
                    category={category}
                    index={index} 
                    categories={categories}
                    setCategories={(newCategories) => setState(prev => ({ ...prev, categories: newCategories }))}
                    onRemove={(category) => {
                      deleteCategory({
                        categoryId: category.categoryId,
                        parentCategoryId: category.parentCategoryId,
                        clientId,
                      });
                    }}
                    onDuplicate={onCategoryDuplicate}
                    onViewProducts={onViewProductsClick}
                    search={search}
                    onCategoryUpdate={onCategoryUpdate}
                    showDragHandle={!!defineOrder}
                    handleSubCategoryDragEnd={(resultList) => handleSubCategoryDragEnd(resultList)}
                    categoriesSortOrder={subCategoriesSortOrder}
                    categoryIsRemovingId={categoryIsRemovingId}
                    isForStorefront={isForStorefront}
                    isView={isView}
                  />
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  ) : (
    <div className="no-categories-wrapper pt-5">
      <div className="f-16 line-height-24 f-600 f-black text-center">
        No categories found
      </div>
    </div>
  )
)

const Loader = () => {
  return (
    <>
      <ContentLoader
        speed={2}
        width={"100%"}
        height={"32px"}
        backgroundColor="#F6F8FB"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
      </ContentLoader>

      <ContentLoader
        speed={2}
        width={"100%"}
        height={"600px"}
        backgroundColor="#F6F8FB"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
      </ContentLoader>
    </>
  )
}
